module.exports = __webpack_public_path__ + "static/media/image.02b38450.svg";